import ofertaReferidosEmprendedores from "@/config/brands/ofertaReferidosEmprendedores";

describe("ofertaReferidosEmprendedores", () => {
  it("should have a googleAnalyticsId", () => {
    expect(ofertaReferidosEmprendedores.googleAnalyticsId).toBeNull();
  });

  it("should have a pasos object", () => {
    expect(typeof ofertaReferidosEmprendedores.pasos).toBe("object");
  });

  it("should have correct titles and subtitles in pasos", () => {
    expect(ofertaReferidosEmprendedores.pasos.paso1.titulo).toEqual(
      "Datos del emprendimiento o comercio de tu cliente"
    );
    expect(ofertaReferidosEmprendedores.pasos.paso1.subtitulo).toEqual(
      "Ingresá los siguientes datos para que podamos contactarlo"
    );

    expect(ofertaReferidosEmprendedores.pasos.paso2.titulo).toEqual(
      "Datos del emprendimiento o comercio de tu cliente"
    );
    expect(ofertaReferidosEmprendedores.pasos.paso2.subtitulo).toEqual(
      "Ingresá los siguientes datos para que podamos contactarlo"
    );

    expect(ofertaReferidosEmprendedores.pasos.paso3.titulo).toEqual(
      "Datos de contacto de tu cliente"
    );
    expect(ofertaReferidosEmprendedores.pasos.paso3.subtitulo).toEqual(
      "Ingresá los siguientes datos para que podamos contactarlo"
    );

    expect(ofertaReferidosEmprendedores.pasos.paso4.titulo).toEqual(
      "Seleccioná una sucursal"
    );
    expect(ofertaReferidosEmprendedores.pasos.paso4.subtitulo).toEqual(
      "Elegí la sucursal en donde tu cliente gestionará sus productos"
    );
  });
});
